import React from 'react';

const trustPoints = [
  'UK registered company',
  'ICO registered',
  'Secure payments through Stripe & PayPal',
  'No ongoing VPN subscription',
];

const HomepageTrustStrip = () => (
  <section className="homepage-trust-strip" aria-label="PhantomPath trust information">
    <div>
      {trustPoints.map((point) => <span key={point}>{point}</span>)}
    </div>
  </section>
);

export default HomepageTrustStrip;
